import { Card as MaterialCard } from "@mui/material";
import { BoxProps } from "./types";

const Box = ({ children, className, style }: BoxProps) => {
  return (
    <MaterialCard className={className} style={style}>
      {children}
    </MaterialCard>
  );
};

export default Box;
